/**
 * Where the public directory lives, on the application's own domain.
 *
 * Profiles are nested under the directory rather than sitting at the root, so
 * a slug occupies no path the application could ever want: everything below
 * this prefix belongs to the directory and nothing else.
 *
 * Kept in the domain layer rather than in routes.tsx so that pages can use it
 * without importing the route table that imports them.
 */
export const DIRECTORY_PATH = "/therapist-catalog";

export const profilePath = (slug: string) => `${DIRECTORY_PATH}/${slug}`;
